/* src/components/Login.js - v3.1 - Updated Title */
import React, { useState, useEffect } from 'react';

function Login({ onLogin, onClose }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotUsername, setForgotUsername] = useState('');
  const [forgotStatus, setForgotStatus] = useState('');

  // ESC Key Listener
  useEffect(() => {
      const handleEsc = (e) => {
          if (e.key === 'Escape' && onClose) {
              onClose();
          }
      };
      window.addEventListener('keydown', handleEsc);
      return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (isRegistering && !email) {
        setError("Email is required for registration.");
        return;
    }

    const endpoint = isRegistering ? '/api/register' : '/api/login';
    const payload = { username, password };
    if (isRegistering) payload.email = email;
    
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      const data = await res.json();
      
      if (res.ok) {
        if (isRegistering) {
            alert("Account created! Please login.");
            setIsRegistering(false);
            setPassword('');
        } else {
            onLogin(data);
        }
      } else {
        setError(data.error || 'Something went wrong');
      }
    } catch (err) {
      setError('Server error. Please try again later.');
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setForgotStatus('Sending instructions...');
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: forgotUsername })
      });
      const data = await res.json();
      if (res.ok) {
        setForgotStatus('Email sent! Check your inbox.');
        setForgotUsername('');
      } else {
        setForgotStatus(data.error || 'User not found.');
      }
    } catch (err) {
      setForgotStatus('Server error.');
    }
  };

  return (
    <div 
        style={{ 
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', 
            display: 'flex', alignItems: 'center', justifyContent: 'center', 
            zIndex: 10000, background: 'rgba(0, 0, 0, 0.85)', backdropFilter: 'blur(8px)'
        }} 
        onClick={onClose} 
    >
      
      <div 
        className="card" 
        style={{ width: '90%', maxWidth: '400px', padding: '40px', textAlign: 'center', position: 'relative' }}
        onClick={(e) => e.stopPropagation()} 
      >
        <button 
            onClick={onClose}
            style={{ 
                position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', 
                color: '#fff', fontSize: '24px', cursor: 'pointer', zIndex: 20, opacity: 0.7 
            }}
            title="Close"
        >
            ✕
        </button>

        {/* UPDATED TITLE */}
        <h2 style={{ marginBottom: '10px', color: 'white', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '24px' }}>
          NUBIX SOCIAL NETWORK
        </h2>
        
        <p style={{ color: '#a0a0b0', marginBottom: '30px', fontSize: '0.9rem' }}>
            {isRegistering ? 'Create an account to join the conversation.' : 'Login to access your profile and messages.'}
        </p>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <input 
            type="text" 
            placeholder="Username" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)}
            className="post-input"
            autoFocus
            required
          />
          
          {isRegistering && (
            <input 
                type="email" 
                placeholder="Email Address" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                className="post-input"
                required
            />
          )}

          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            className="post-input"
            required
          />
          
          {error && <div style={{ color: '#ff4757', fontSize: '14px', background: 'rgba(255, 71, 87, 0.1)', padding: '10px', borderRadius: '8px' }}>{error}</div>}
          
          <button 
            type="submit" 
            style={{ 
                padding: '12px', borderRadius: '30px', border: 'none', 
                background: 'linear-gradient(45deg, #ff4757, #ff6b81)', 
                color: 'white', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' 
            }}
          >
            {isRegistering ? 'Create Account' : 'Login'}
          </button>
        </form>

        <div style={{ marginTop: '20px', fontSize: '14px', color: '#a0a0b0' }}>
          {isRegistering ? 'Already have an account? ' : "Don't have an account? "}
          <span 
            onClick={() => { setIsRegistering(!isRegistering); setError(''); }} 
            style={{ color: '#ff4757', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {isRegistering ? 'Login' : 'Register'}
          </span>
        </div>

        {!isRegistering && (
             <div style={{ marginTop: '15px', fontSize: '13px' }}>
                 <span 
                    onClick={() => { setShowForgotModal(true); setForgotStatus(''); }}
                    style={{ color: '#a0a0b0', cursor: 'pointer', textDecoration: 'underline' }}
                 >
                    Forgot Password?
                 </span>
             </div>
        )}
      </div>

      {showForgotModal && (
        <div style={{
            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10001
        }} onClick={() => setShowForgotModal(false)}>
            <div className="card" style={{ width: '90%', maxWidth: '350px', padding: '30px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                <h3 style={{ color: 'white', marginBottom: '15px' }}>Reset Password</h3>
                <input 
                    type="text" 
                    placeholder="Enter Username" 
                    value={forgotUsername} 
                    onChange={(e) => setForgotUsername(e.target.value)}
                    className="post-input"
                    style={{ marginBottom: '15px' }}
                />
                <button 
                    onClick={handleForgotSubmit}
                    style={{ 
                        width: '100%', padding: '10px', borderRadius: '30px', border: 'none', 
                        background: 'linear-gradient(45deg, #ff4757, #ff6b81)', 
                        color: 'white', fontWeight: 'bold', cursor: 'pointer'
                    }}
                >
                    Send Instructions
                </button>
                {forgotStatus && <div style={{ marginTop: '15px', color: '#ccc', fontSize: '13px' }}>{forgotStatus}</div>}
            </div>
        </div>
      )}
    </div>
  );
}

export default Login;
